// extracted by mini-css-extract-plugin
export default {"confirmation-modal":"confirmation-modal_confirmation-modal__bXRgz"};